import { render, staticRenderFns } from "./TabDistribuicaoOperadorInput.vue?vue&type=template&id=039043f3&"
import script from "./TabDistribuicaoOperadorInput.vue?vue&type=script&lang=js&"
export * from "./TabDistribuicaoOperadorInput.vue?vue&type=script&lang=js&"
import style0 from "./TabDistribuicaoOperadorInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports